import { createContext } from "react";
export const FormContext = createContext<any>(null);

const FormProvider = FormContext.Provider;
const FormConsumer = FormContext.Consumer;
export { FormProvider, FormConsumer };
